<template>
    <section>
        <div id='divMap' style="padding:5px;height:400px;"></div>
        <el-form :model="orderInfo" label-width="120px" ref="orderInfo">
            <div style="margin-top: 10px; ">
                <!--<el-form-item label="用户昵称">
                {{orderInfo.UserInfo.nickName}}
                </el-form-item>-->
                <el-form-item label="发件人姓名">
                    {{orderInfo.SenderName}}
                </el-form-item>
                <el-form-item label="发件人电话">
                    {{orderInfo.SenderMobile}}
                </el-form-item>
                <el-form-item label="发件地址">
                    {{orderInfo.SenderAddress}}
                </el-form-item>
                <el-form-item label="收件人姓名">
                    {{orderInfo.RecipientName}}
                </el-form-item>
                <el-form-item label="收件人电话">
                    {{orderInfo.RecipientMobile}}
                </el-form-item>
                <el-form-item label="收件地址">
                    {{orderInfo.RecipientAddress}}
                </el-form-item>
                <!--<el-form-item label="驾驶员姓名">
            {{orderInfo.CourierInfo.Name}}
            </el-form-item>
            <el-form-item label="驾驶员电话">
                {{orderInfo.CourierInfo.Phone}}
            </el-form-item>-->

                <el-form-item label="订单号码">{{orderInfo.OrderNo}}</el-form-item>
                <el-form-item label="物品名称">{{orderInfo.GoodsName}}</el-form-item>
                <!--<el-form-item label="物品重量(KG)">
                {{orderInfo.GoodsWeight}}
            </el-form-item>
            <el-form-item label="物品体积（m3）">
                {{orderInfo.GoodsVolume}}
            </el-form-item>-->
                <el-form-item label="物品数量">{{orderInfo.GoodsQuantity}}</el-form-item>

                <el-form-item label="发件拍照">
                    <div class="list body ebody">
                        <div v-for="(e, index) in senderPicturesList" style="width:80px;float:left; ">
                            <span>
                                <el-image v-image-preview style="width: 50px; height: 50px; margin-bottom:-4px"
                                          :src="`${e.Picture}`">
                                </el-image>
                            </span>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="订单状态">
                    {{orderInfo.StatusName}}
                </el-form-item>
                <!--<el-form-item label="订单备注">
                    {{orderInfo.Remark}}
                </el-form-item>-->
                <el-form-item label="下单时间">
                    {{orderInfo.CreationTime}}
                </el-form-item>
                <!--<el-form-item label="距离（米）">
                {{orderInfo.Distance}}
            </el-form-item>-->
                <el-form-item label="接单时间" v-if="orderInfo.Status>=2 ||orderInfo.Status<=4">
                    {{orderInfo.AcceptTime}}
                </el-form-item>
                <el-form-item label="取货时间" v-if="orderInfo.Status>=3 ||orderInfo.Status<=4">
                    {{orderInfo.PickUpTime}}
                </el-form-item>
                <!--<el-form-item label="取货备注">
                    {{orderInfo.PickUpNote}}
                </el-form-item>
                <el-form-item label="取货地址">
                    {{orderInfo.PickUpAddress}}
                </el-form-item>-->


                <el-form-item label="送达时间" v-if="orderInfo.Status==4">
                    {{orderInfo.DeliveryTime}}
                </el-form-item>
                <!--<el-form-item label="送达拍照">
                    <div class="list body ebody">
                        <div v-for="(e, index) in deliveryPicturesList" style="width:80px;float:left; ">
                            <span>
                                <el-image v-image-preview style="width: 50px; height: 50px; margin-bottom:-4px"
                                          :src="`${e.Picture}`">
                                </el-image>
                            </span>
                        </div>
                    </div>
                </el-form-item>-->
                <!--<el-form-item label="送达备注">
                    {{orderInfo.DeliveryNote}}
                </el-form-item>-->
                <!--<el-form-item label="送达地址">
                    {{orderInfo.DeliveryAddress}}
                </el-form-item>-->

                <!--<el-form-item label="支付时间">
            {{orderInfo.PayTime}}
            </el-form-item>-->
            </div>
        </el-form>
    </section>
</template>

<script>
    import util from "../../../util/date";
    import {
        getOrderInfo
    } from "../../api/api";
    /* import { getButtonList } from "../../promissionRouter";*/
    /*import Toolbar from "../../components/Toolbar";*/
    //import global from '../../components/Global'//引用全局模块
    //import moment from 'moment'

    export default {
        /* components: { Toolbar },*/
        data() {
            return {

                markerUrl1: require("../../assets/User32.png"),  // 点标记图片路径
                markerUrl2: require("../../assets/SendUser32.png"),  // 点标记图片路径
                markerUrl3: require("../../assets/RecipientUser32.png"),  // 点标记图片路径
                map: '',
                zoom: 12,  // 地图一开始的缩放级别
                center: new window.TMap.LatLng(31.385424, 120.980765),  // 地图一开始的中心点
                markerLayer: '',
                markerArr: [],

                tableHeight: 600,
                orderInfo: {},
                OId: 0,
                senderPicturesList: [],
                deliveryPicturesList: [],
                listLoading: false,
            };
        },
        methods: {
            formatCreationTime: function (row, column) {
                return !row.CreationTime || row.CreationTime == ""
                    ? ""
                    : util.formatDate.format(new Date(row.CreationTime), "yyyy-MM-dd hh:mm:ss");
            },
            formatAcceptTime: function (row, column) {
                return !row.AcceptTime || row.AcceptTime == ""
                    ? ""
                    : util.formatDate.format(new Date(row.AcceptTime), "yyyy-MM-dd hh:mm:ss");
            },
            formatPickUpTime: function (row, column) {
                return !row.PickUpTime || row.PickUpTime == ""
                    ? ""
                    : util.formatDate.format(new Date(row.PickUpTime), "yyyy-MM-dd hh:mm:ss");
            },
            formatDeliveryTime: function (row, column) {
                return !row.DeliveryTime || row.DeliveryTime == ""
                    ? ""
                    : util.formatDate.format(new Date(row.DeliveryTime), "yyyy-MM-dd hh:mm:ss");
            },
            formatPayTime: function (row, column) {
                return !row.PayTime || row.PayTime == ""
                    ? ""
                    : util.formatDate.format(new Date(row.PayTime), "yyyy-MM-dd hh:mm:ss");
            },
            //获取用户列表
            handleQuery() {
                let para = {
                    OId: this.OId
                };
                this.listLoading = true;

                //NProgress.start();
                getOrderInfo(para).then((res) => {
                    this.orderInfo = res.data.response;

                    this.deliveryPicturesList = [];
                    if (this.orderInfo.DeliveryPictures != null && this.orderInfo.DeliveryPictures != "") {
                        var RVoucher = String(this.orderInfo.DeliveryPictures);
                        var vouchers = RVoucher.split(",");
                        //console.log('bbb');
                        for (var i = 0; i < vouchers.length; i++) {
                            var inNo = vouchers[i].toString();
                            if (inNo != null && inNo != "") {
                                this.deliveryPicturesList.push({
                                    Picture: inNo
                                });
                            }
                        }
                    }
                    this.senderPicturesList = [];
                    if (this.orderInfo.SenderPictures != null && this.orderInfo.SenderPictures != "") {
                        var RVoucher = String(this.orderInfo.SenderPictures);
                        var vouchers = RVoucher.split(",");
                        //console.log('bbb');
                        for (var i = 0; i < vouchers.length; i++) {
                            var inNo = vouchers[i].toString();
                            if (inNo != null && inNo != "") {
                                this.senderPicturesList.push({
                                    Picture: inNo
                                });
                            }
                        }
                    }
                    this.initMap(this.center, this.zoom)  // 初始化页面后直接初始化地图

                    this.listLoading = false;
                    //NProgress.done();
                });
            },



            initMap(center, zoom) {
                this.map = new window.TMap.Map(document.getElementById('divMap'), {
                    center: center,//设置地图中心点坐标
                    zoom: zoom,   //设置地图缩放级别
                    pitch: 0,  //设置俯仰角
                    rotation: 0    //设置地图旋转角度
                });

                //this.markerLayer = new window.TMap.MultiMarker({  // 创建标记层
                //    map: this.map,  //指定地图容器
                //    geometries: [],
                //    styles: {  // 点标记样式
                //        "mystyle": new window.TMap.MarkerStyle({
                //            "width": 200,
                //            "height": 200,
                //            "src": this.markerUrl,
                //            "anchor": { x: 10, y: 10 },
                //            "opacity": 0.5
                //        })
                //    }
                //});

                //获取所有驾驶员
                //getAllCourierList() {
                //let _this = this;
                let para = {
                };
                this.listLoading = false;
                this.markerArr = [];
                if (this.orderInfo != null && this.orderInfo.Status>0) {
                    this.markerArr.push({
                        // "id": String(this.allCouriers[i].Id),
                        "styleId": 'marker2',
                        "position": new TMap.LatLng(this.orderInfo.RecipientLatitude, this.orderInfo.RecipientLongitude),
                        //"content": "收件人",// this.orderInfo.RecipientName, // 标注文本
                        "properties": {
                            "title": this.orderInfo.RecipientName,
                            "content": "收件人"
                        }
                    });
                    this.markerArr.push({
                        //"id": String(this.allCouriers[i].Id),
                        "styleId": 'marker3',
                        "position": new TMap.LatLng(this.orderInfo.SenderLatitude, this.orderInfo.SenderLongitude),
                        //"content": "寄件人",//this.orderInfo.RecipientName, // 标注文本
                        "properties": {
                            "title": this.orderInfo.RecipientName,
                            "content": "寄件人"
                        }
                    });
                    if (this.orderInfo.Status == 3 || this.orderInfo.Status == 2) {
                        this.markerArr.push({
                            //"id": String(this.allCouriers[i].Id),
                            "styleId": 'marker1',
                            "position": new TMap.LatLng(this.orderInfo.DeliveryLatitude, this.orderInfo.DeliveryLongitude),
                            //"content": "驾驶员位置",//this.orderInfo.RecipientName, // 标注文本
                            "properties": {
                                "title": this.orderInfo.RecipientName,
                                "content": "驾驶员位置"
                            }
                        });
                    }
                    console.log(this.markerArr);

                    //初始化marker
                    var marker = new TMap.MultiMarker({
                        id: 'marker-layer',
                        map: this.map,
                        styles: {
                            "marker1": new TMap.MarkerStyle({
                                "width": 25,
                                "height": 25,
                                "anchor": { x: 16, y: 32 },
                                "src": this.markerUrl1,// 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/markerDefault.png',

                                "color": '#3777FF', // 颜色属性
                                "size": 20, // 文字大小属性
                                "offset": { x: 0, y: -20 }, // 文字偏移属性单位为像素
                                "angle": 0, // 文字旋转属性
                                "alignment": 'center', // 文字水平对齐属性
                                "verticalAlignment": 'middle', // 文字垂直对齐属性

                            }),
                            "marker2": new TMap.MarkerStyle({
                                "width": 25,
                                "height": 25,
                                "anchor": { x: 16, y: 32 },
                                "src": this.markerUrl2,// 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/markerDefault.png',

                                "color": '#3777FF', // 颜色属性
                                "size": 20, // 文字大小属性
                                "offset": { x: 0, y: -20 }, // 文字偏移属性单位为像素
                                "angle": 0, // 文字旋转属性
                                "alignment": 'center', // 文字水平对齐属性
                                "verticalAlignment": 'middle', // 文字垂直对齐属性

                            }),
                            "marker3": new TMap.MarkerStyle({
                                "width": 25,
                                "height": 25,
                                "anchor": { x: 16, y: 32 },
                                "src": this.markerUrl3,// 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/markerDefault.png',

                                "color": '#3777FF', // 颜色属性
                                "size": 20, // 文字大小属性
                                "offset": { x: 0, y: -20 }, // 文字偏移属性单位为像素
                                "angle": 0, // 文字旋转属性
                                "alignment": 'center', // 文字水平对齐属性
                                "verticalAlignment": 'middle', // 文字垂直对齐属性

                            }),
                        },
                        geometries: this.markerArr
                    });
                    //初始化
                    var bounds = new TMap.LatLngBounds();

                    //判断标注点是否在范围内
                    this.markerArr.forEach(function (item) {
                        //若坐标点不在范围内，扩大bounds范围
                        if (bounds.isEmpty() || !bounds.contains(item.position)) {
                            bounds.extend(item.position);
                        }
                    })
                    //设置地图可视范围
                    this.map.fitBounds(bounds, {
                        padding: 100 // 自适应边距
                    });

                }
                this.listLoading = false;
            },

        },
        mounted() {
            this.OId = this.$route.query.OId;
            this.handleQuery();

           


            //let routers = window.localStorage.router
            //    ? JSON.parse(window.localStorage.router)
            //    : [];
            //this.buttonList = getButtonList(this.$route.path, routers);
            //this.buttonList.forEach(item => {
            //    console.log(item.Func);
            //    if (item.Func == "handleEdit") {
            //        this.isEdit = true;
            //    }
            //    else if (item.Func == "handleDel") {
            //        this.isDelete = true;
            //    }
            //    else if (item.Func == "handleExport") {
            //        this.isExport = true;
            //    } else if (item.Func == "handleCancelOrder") {
            //        this.isCancelOrder = true;
            //    } else if (item.Func == "handleModifyCourier") {
            //        this.isModifyCourier = true;
            //    }
            //});

            //this.$nextTick(function () {
            //    if (window.innerWidth > 700) {
            //        //在页面渲染完成后
            //        this.tableHeight = window.innerHeight - this.$refs.table.$el.getBoundingClientRect().top - 50
            //        this.$refs.table.$el.getBoundingClientRect().top //表格距离浏览器的高度
            //        var that = this
            //        // 添加监听窗口大小变化事件
            //        window.onresize = function () {
            //            that.tableHeight = window.innerHeight - that.$refs.table.$el.getBoundingClientRect().top - 50
            //        }
            //    };
            //})
        },
    };
</script>
<style>
    .el-scrollbar__view {
        height: 100%;
        width: 100%;
    }

  
</style>
<style scoped>

    .map {
        width: 100%;
        /* min-height: 550px;
        height: auto;*/
        height: 400px;
    }

    .custom-tbl /deep/ .has-gutter .el-checkbox {
        display: none;
    }

    #divMap {
        /*地图(容器)显示大小*/ /*设置为全屏，位于最下层*/
        width: 100%;
        height: 40%;
        position: relative !important;
        top: 0px;
        bottom: 0px;
        left: 0px;
        right: 0px;
        z-index: 99;
    }

    .el-form-item {
        margin-bottom: 5px !important;
        border-bottom: 1px solid #dcdfe6;
    }
    /*.el-form-item__label{
      font-size:12px;
      font-weight:500;
  }*/
</style>
<style>
    .vue-directive-image-previewer {
        z-index: 9999;
    }
</style>
